import { render, staticRenderFns } from "./NewContractList.vue?vue&type=template&id=04ff0831&scoped=true"
import script from "./NewContractList.vue?vue&type=script&lang=js"
export * from "./NewContractList.vue?vue&type=script&lang=js"
import style0 from "./NewContractList.vue?vue&type=style&index=0&id=04ff0831&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ff0831",
  null
  
)

export default component.exports